import { Backdrop, CircularProgress } from "@mui/material";

const AuthorizationOverlay = ({ open }) => (
  <Backdrop
    open={open}
    sx={{
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "#fff",
      position: "fixed",
      inset: 0,
      width: "100vw",
      height: "100vh",
      zIndex: (theme) => theme.zIndex.modal + 1,
    }}
    aria-label="Waiting for authorization"
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);

export default AuthorizationOverlay;
